/* SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
import { firstValueFrom, filter, timeout } from "rxjs";
import { type Behavior } from "./Behavior";
import { requestConferenceInput } from "./MediaDevices";

type CaptureState = {
  enabled$: Behavior<boolean>;
  syncing$: Behavior<boolean>;
  setEnabled$: Behavior<((enabled: boolean) => void) | null>;
};
// Report the publisher's completed state, never the optimistic requested value.
export async function changeConferenceMedia(model: CaptureState, kind: "audioinput" | "videoinput", desired: boolean): Promise<boolean> {
  if (!desired && !model.setEnabled$.value) return false;
  if (desired && !model.setEnabled$.value) await requestConferenceInput(kind);
  const set = await firstValueFrom(model.setEnabled$.pipe(filter(value => value !== null), timeout(10000)));
  set(desired);
  await firstValueFrom(model.syncing$.pipe(filter(value => !value), timeout(10000)));
  return model.enabled$.value;
}
